import React from 'react';
import type { PropCarouselAsset } from '../../../../propValues.types';
import { useIsMobileScreen } from '@shared/utils/media/useMediaScreens';
import { getVisibleSlides } from '../../../../propValues.helpers';
import ContentCarousel from './components/Carousel';
import { ValuePropTileShell } from './ValuePropTileShell';

type ValuePropListCardProps = Readonly<{
  data: PropCarouselAsset & { type: 'propCarousel' };
  hideTilePrice?: boolean;
}>;

// How long each slide is shown before auto-advancing.
const AUTO_ROTATE_PERIOD_MS = 3000;

/**
 * The pinned top-left gallery tile that rotates through an ordered list of value props. Unlike
 * {@link ValuePropCard} (one prop, rotating its own media), each slide is a distinct prop with its
 * own click-through link, so we collapse every slide to its current-breakpoint asset (dropping the
 * desktop-only foil video on mobile) and hand the per-slide links to the carousel via `slideNav`.
 */
export const ValuePropListCard = (props: ValuePropListCardProps) => {
  const isMobile = useIsMobileScreen();
  const { data, hideTilePrice } = props;
  const visibleSlides = getVisibleSlides(data.slides, isMobile);

  if (!visibleSlides.length) return null;

  return (
    <ValuePropTileShell
      row={data.row}
      column={data.column}
      columns={data.columns}
      hideTilePrice={hideTilePrice}
    >
      <ContentCarousel
        autoRotatePeriodMs={AUTO_ROTATE_PERIOD_MS}
        pauseOnHover
        content={visibleSlides.map(slide => slide.asset)}
        slideNav={visibleSlides.map(slide => ({ link: slide.link, telemetryId: slide.telemetryId }))}
      />
    </ValuePropTileShell>
  );
};
